import { Component, computed, ChangeDetectionStrategy } from '@angular/core';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { TranslatePipe } from '../../../../../shared/pipes/translate.pipe';

@Component({
  selector: 'app-readonly-field',
  imports: [FormlyModule, TranslatePipe],
  templateUrl: './readonly-field.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './readonly-field.component.css',
})
export class ReadonlyFieldComponent extends FieldType<FieldTypeConfig> {
  get originalType(): string {
    return (this.props['originalType'] as string) ?? 'text';
  }

  get resolvedOptions(): { value: any; label: string }[] {
    const opts = this.props['options'] as any;
    return Array.isArray(opts) ? opts : [];
  }

  displayValue = computed(() => {
    const value = this.formControl.value;
    if (value === null || value === undefined || value === '') {
      return null;
    }

    switch (this.originalType) {
      case 'checkbox':
        return value ? 'submission.view.checkbox.yes' : 'submission.view.checkbox.no';

      case 'radio':
      case 'dropdown': {
        const opt = this.resolvedOptions.find((o) => o.value === value);
        return opt?.label ?? String(value);
      }

      case 'select':
      case 'checkbox-group': {
        if (Array.isArray(value)) {
          return value
            .map((v) => this.resolvedOptions.find((o) => o.value === v)?.label ?? String(v))
            .join(', ');
        }
        const opt = this.resolvedOptions.find((o) => o.value === value);
        return opt?.label ?? String(value);
      }

      default:
        return String(value);
    }
  });

  get isCheckbox(): boolean {
    return this.originalType === 'checkbox';
  }
}
